import { useTranslation } from "react-i18next";

import LoadingCircle from "../../../../components/loadingCircle/LoadingCircle";
import useInboundDeliveriesCountsQuery from "../../../../hooks/graphql-hooks/queries/useInboundDeliveriesCountsQuery";
import { DeliveryCount } from "../../../../models/deliveryCount";
import { ITag } from "../../../../models/tag";
import "./YourDeliveriesCard.scss";

interface YourDeliveriesCardProps {
  tag: ITag;
  count: number;
  setDeliveryCount: (count: DeliveryCount) => void;
}

const YourDeliveriesCard = (props: YourDeliveriesCardProps) => {
  const { t } = useTranslation();
  const { tag, count, setDeliveryCount } = props;

  const { loading } = useInboundDeliveriesCountsQuery({
    variables: {
      plannedDeliveryDateFilter:
        tag?.inputParameters?.plannedDeliveryDateFilter || null,
      plannedDeliveryDateFilterMatch:
        tag?.inputParameters?.plannedDeliveryDateFilterMatch || null,
    },
    dataAction: (count) => setDeliveryCount({ key: tag.name, value: count }),
  });

  return (
    <div data-testid="your-deliveries-card" className="your-deliveries-card">
      <div className="your-deliveries-card-description">{t(tag.name)}</div>
      {loading ? (
        <LoadingCircle />
      ) : (
        <div
          data-testid="your-deliveries-card-count"
          className="your-deliveries-card-count"
        >
          {count}
        </div>
      )}
    </div>
  );
};
export default YourDeliveriesCard;
